import { render, staticRenderFns } from "./Estatus.vue?vue&type=template&id=457efd5e&"
import script from "./Estatus.vue?vue&type=script&lang=js&"
export * from "./Estatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports